module.exports = __webpack_public_path__ + "static/media/256.802c58f4.wav";